<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-minus"
  >
    <path d="M22.91,13.09c.6,0,1.09-.49,1.09-1.09s-.49-1.09-1.09-1.09H1.09c-.6,0-1.09.49-1.09,1.09s.49,1.09,1.09,1.09" />
  </svg>
</template>
